import React, { useEffect, useState, useSyncExternalStore } from "react";
import "../../Styles/banner.css";
import { IoIosSearch } from "react-icons/io";
import { MdOutlineHomeWork } from "react-icons/md";
import { FiMapPin } from "react-icons/fi";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AdvanceFilter from "../../components/AdvanceFilter";
import { VscSymbolKeyword } from "react-icons/vsc";

const Banner = ({ categoryData, locationData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("rent");
  const [keyword, setKeyword] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [propertyTypeId, setPropertyTypeId] = useState("");
  const [location, setLocation] = useState("");
  const [locationId, setLocationId] = useState("");
  const [bedroom, setBedroom] = useState("");
  const [bathroom, setBathroom] = useState("");
  const [areaSqft, setAreaSqft] = useState("");
  const [amenities, setAmenities] = useState([]);
  const navigate = useNavigate();

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (e) => {
    closePopup();
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const handleSearch = () => {
    if (!propertyType && !location) {
      alert("Select PropertyType or Location");
      return;
    }
    const params = new URLSearchParams();
    if (selectedType) {
      params.append("type", selectedType);
    }
    if (keyword) {
      params.append("keyword", keyword);
    }
    if (propertyType) {
      params.append("property_type", `${propertyType}-${propertyTypeId}`);
    }
    if (location) {
      params.append("location", `${location}-${locationId}`);
    }
    if (bedroom) {
      params.append("bedroom", `${bedroom}`);
    }
    if (bathroom) {
      params.append("bathroom", `${bathroom}`);
    }
    if (areaSqft) {
      params.append("area_sqft", `${areaSqft}`);
    }
    if (amenities.length) {
      params.append("amenities", `${amenities}`);
    }
    params.append("page", 1)
    const queryString = params.toString();
    navigate(`/property-listing?${queryString}`);
  };

  return (
    <>
      <section className="banner">
        <div className="container mt-5 p-4 rounded shadow-sm ">
          <div className="property-options">
            <button
              className={`option-btn ${selectedType === "rent" ? "active" : ""}`}
              onClick={() => setSelectedType("rent")}
            >
              For Rent
            </button>
            <button
              className={`option-btn ${selectedType === "sell" ? "active" : ""}`}
              onClick={() => setSelectedType("sell")}
            >
              For Sell
            </button>
            <button
              className={`option-btn ${selectedType === "developer" ? "active" : ""
                }`}
              onClick={() => setSelectedType("developer")}
            >
              Developer
            </button>
          </div>
          <div className="row search-box py-4 align-items-end">
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-3 position-relative">
              <label htmlFor="keyword" className="form-label">
              <VscSymbolKeyword /> Keyword
              </label>
              <div className="position-relative keyword-input">
                <input
                  type="text"
                  className="form-control"
                  id="keyword"
                  placeholder="Enter keyword"
                  onChange={(e) => setKeyword(e.target.value)}
                />
                <IoIosSearch />
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-3">
              <label htmlFor="propertyType" className="form-label">
                <MdOutlineHomeWork /> Property Type
              </label>
              <select
                className="form-select"
                id="propertyType"
                onChange={(e) => {
                  const selectedOption =
                    e.target.options[e.target.selectedIndex];
                  const selectedKey = selectedOption.getAttribute("data-key");
                  setPropertyType(e.target.value);
                  setPropertyTypeId(selectedKey);
                }}
              >
                <option value="">Select type</option>
                {categoryData &&
                  categoryData.map((data) => {
                    return (
                      <option
                        key={data.id}
                        value={data.slug}
                        data-key={data.id}
                      >
                        {data.category_name}
                      </option>
                    );
                  })}
              </select>
            </div>
            {/* Location Dropdown */}
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-3 location-col">
              <label htmlFor="location" className="form-label">
                <FiMapPin /> Location
              </label>
              <select
                className="form-select"
                id="location"
                onChange={(e) => {
                  const selectedOption =
                    e.target.options[e.target.selectedIndex];
                  const selectedKey = selectedOption.getAttribute("data-key");
                  setLocation(e.target.value);
                  setLocationId(selectedKey);
                }}
              >
                <option selected="">Select location</option>
                {locationData &&
                  locationData.map((item, i) => (
                    <option key={item.id} value={item.slug} data-key={item.id}>
                      {item.city}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 banner-search-btn">
              <button
                type="button"
                className="btn btn-outline-secondary advanced-btn d-flex align-items-center"
                onClick={togglePopup}
              >
                <MdTune /> Advanced
              </button>
              <button
                type="button"
                className="btn btn-primary btn-block search-btn"
                onClick={handleSearch}
              >
                Search Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {isOpen ? (
        <div className="modal-overlay " onClick={handleClickOutside}>
          <div
            className="modal-content container"
            onClick={(e) => e.stopPropagation()}
          >
            <AdvanceFilter
              closePopup={closePopup}
              setBedroom={setBedroom}
              setBathroom={setBathroom}
              setAreaSqft={setAreaSqft}
              setAmenities={setAmenities}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Banner;
